export const banksListTransactions = [
    { value: "INTERBANK-PE", name: "INTERBANK-PE" },
    { value: "COMERCIO-PE", name: "COMERCIO-PE" },
    { value: "ALFIN-PE", name: "ALFIN-PE" },
    { value: "BBVA-PE", name: "BBVA-PE" },
    { value: "SCOTIA-PE", name: "SCOTIA-PE" },
    { value: "BCP-PE", name: "BCP-PE" },
  ]